import React from "react";
import { Link } from "react-router-dom";
import { slugToCity, toUrlSlug } from "@/data/serviceAreas";

export default function CityNearbyAreas({ siblings }) {
  if (!siblings || siblings.length === 0) return null;
  return (
    <div className="bg-white p-6 rounded border border-gray-200">
      <div className="br-eyebrow text-br-bronze">Nearby Service Areas</div>
      <div className="mt-3 flex flex-wrap gap-2">
        {siblings.map((s) => (
          <Link key={s} to={`/service-areas/${toUrlSlug(s)}`} className="px-3 py-1.5 text-xs uppercase tracking-widest rounded border border-gray-200 hover:border-br-bronze hover:text-br-bronze transition">{slugToCity(s)}, TX</Link>
        ))}
      </div>
    </div>
  );
}
